import React, { useCallback } from "react";
import ResourcePickerButton from "../../../../common/ResourcePickerButton/ResourcePickerButton.js";
import CustomErrorWrapper from "./CustomErrorWrapper.js";

const SpecificProductField = ({ input, meta: { error } }) => {
  const handleAddProducts = useCallback((selectPayload) => {
    input.onChange(selectPayload?.selection[0]?.id ? [{
      id: selectPayload.selection[0].id,
      handle: selectPayload.selection[0].handle
    }] : []);
  }, [input]);

  return (
    <>
      <ResourcePickerButton
        resourceType={"Product"}
        onSelection={handleAddProducts}
        primary={false}
        disabled={false}
        isLoading={false}
        plain
        selectMultiple={false}
        title="Select Specific Product Page"
        initialSelectionIds={input.value.map(item => ({ id: item.id }))}
      />
      {error && <CustomErrorWrapper error={error} />}
    </>

  );
};

export default SpecificProductField;